import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=0670a1dc&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=ts"
export * from "./Initial.vue?vue&type=script&lang=ts"
import style0 from "./Initial.vue?vue&type=style&index=0&id=0670a1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670a1dc",
  null
  
)

export default component.exports